import { candidatesStore } from "@/services/indexedDB.service";

const Candidates = {
    namespaced: true,
    state: {
        tags: {
            status: [
                {
                    label: "No status",
                    value: "no_status",
                    styleColor: "#989898",
                },
                {
                    label: "In progress",
                    value: "in_progress",
                    styleColor: "yellow",
                },
                {
                    label: "Needs review",
                    value: "need_review",
                    styleColor: "blue",
                },
                {
                    label: "Needs revision",
                    value: "need_revision",
                    styleColor: "orange",
                },
                {
                    label: "Approved",
                    value: "approved",
                    styleColor: "green",
                },
            ],
            rating: [
                {
                    label: "None",
                    value: "none",
                },
                {
                    value: 1,
                },
                {
                    value: 2,
                },
                {
                    value: 3,
                },
                {
                    value: 4,
                },
                {
                    value: 5,
                },
            ],
            color: [
                {
                    label: "None",
                    value: "none",
                    styleColor: "#989898",
                },
                {
                    label: "Red",
                    value: "red",
                    styleColor: "red",
                },
                {
                    label: "Orange",
                    value: "orange",
                    styleColor: "orange",
                },
                {
                    label: "Yellow",
                    value: "yellow",
                    styleColor: "yellow",
                },
                {
                    label: "Green",
                    value: "green",
                    styleColor: "green",
                },
                {
                    label: "Blue",
                    value: "blue",
                    styleColor: "blue",
                },
                {
                    label: "Pink",
                    value: "pink",
                    styleColor: "pink",
                },
                {
                    label: "Purple",
                    value: "purple",
                    styleColor: "purple",
                },
            ],
        },
    },
    mutations: {},
    actions: {
        addTag: async ({commit, rootState, state}, payload) => {
            for await (const file_id of payload.file_ids) {
                let storeData = await candidatesStore.getItem(file_id);

                storeData.tags.forEach((tag, index) => {
                    if (tag.name == payload.tag_name) {
                        storeData.tags[index] = {
                            name: payload.tag_name,
                            value: payload.tag_value,
                        }
                    }
                })

                await candidatesStore.setItem(file_id, storeData);
                commit('UI/UPDATE_CANDIDATE_TAGS', storeData, {root: true});
            }
        },
        removeTag: async ({commit, rootState, state}, payload) => {
            for await (const file_id of payload.file_ids) {
                let storeData = await candidatesStore.getItem(file_id);

                storeData.tags.forEach((tag, index) => {
                    if (tag.name == payload.tag_name) {
                        storeData.tags[index] = {
                            name: payload.tag_name,
                            value: payload.tag_value,
                        }
                    }
                })

                await candidatesStore.setItem(file_id, storeData);
                commit('UI/UPDATE_CANDIDATE_TAGS', storeData, {root: true});
            }
        },
    },
    getters: {
        defaultTags: state => {
            return [
                {
                    name: 'rating',
                    value: 'none'
                },
                {
                    name: 'color',
                    value: 'none'
                },
                {
                    name: 'status',
                    value: 'no_status',
                }
            ]
        },

        getAllCandidates: (state, getters, rootState) => {
            return rootState.UI.candidates;
        }
    },

};

export default Candidates;